//
// Module for Death Audit Providers Index view
//
rs.module("fund/configuration/correspondencesenders/edit",

    [ "common/select-helper" ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, ajaxUrl) {
            var correspondenceSendersForm = $.js(jsSelectors.correspondenceSendersForm);

            var associatedWithUserCheckbox = correspondenceSendersForm.js(jsSelectors.associatedWithUserCheckbox);
            var appUserSelect = correspondenceSendersForm.js(jsSelectors.appUserSelect);
            var appUserSelectHelper = selectHelper.getHelper(appUserSelect);
            var sentFromName = correspondenceSendersForm.js(jsSelectors.sentFromName);
            var department = correspondenceSendersForm.js(jsSelectors.department);
            var jobTitle = correspondenceSendersForm.js(jsSelectors.jobTitle);
            var phoneNumber = correspondenceSendersForm.js(jsSelectors.phoneNumber);
            var extension = correspondenceSendersForm.js(jsSelectors.extension);
            var faxNumber = correspondenceSendersForm.js(jsSelectors.faxNumber);

            associatedWithUserCheckbox.change(setupAttributeControls);
            appUserSelect.change(userChanged);

            function setControlEnableDisable() {
                var checked = associatedWithUserCheckbox[0].checked;
                appUserSelectHelper.setDisabled(!checked);
                sentFromName.prop('disabled', checked);
                if (checked) {
                    sentFromName.clearErrors();
                } else {
                    appUserSelect.clearErrors();
                }

                department.prop('disabled', checked);
                jobTitle.prop('disabled', checked);
                phoneNumber.prop('disabled', checked);
                extension.prop('disabled', checked);
                faxNumber.prop('disabled', checked);
            }

            function setupAttributeControls() {
                setControlEnableDisable()
                sentFromName.val("");
                department.val("");
                jobTitle.val("");
                phoneNumber.val("");
                extension.val("");
                faxNumber.val("");
                appUserSelectHelper.setValue(null);
            }

            function userChanged() {
                sentFromName.val("");
                department.val("");
                jobTitle.val("");
                phoneNumber.val("");
                extension.val("");
                faxNumber.val("");

                $.get(
                    ajaxUrl,

                    {
                        ownerKey : appUserSelect.val()
                    },

                    function (data) {
                        if (data.name) {
                            sentFromName.val(data.name);
                        } else {
                            sentFromName.val(appUserSelect[0].selectedOptions[0].text);
                        }

                        department.val(data.department);
                        jobTitle.val(data.jobTitle);
                        phoneNumber.val(data.phone);
                        extension.val(data.extension);
                        faxNumber.val(data.fax);
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);